module.exports = __webpack_public_path__ + "img/car_shina2_07.f29b4396.jpg";